module.exports = __webpack_public_path__ + "img/riointbig1.5817cc0b.png";